import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PEE_ARIA, type PeeInsightCopy } from "@/lib/looseend/pee";
import { cn } from "@/lib/utils";

/**
 * A single restrained "PEE™ Insight" notice. Never render more than one of
 * these in the same visible context.
 */
export function PeeInsight({
  insight,
  action,
  className,
}: {
  insight: PeeInsightCopy;
  action?: { label: string; onClick: () => void };
  className?: string;
}) {
  return (
    <aside
      className={cn("rounded-xl border border-primary/20 bg-primary-soft px-3 py-2.5", className)}
      aria-label={`${PEE_ARIA} insight`}
    >
      <p className="flex items-start gap-2 text-sm font-medium text-foreground">
        <Sparkles className="mt-0.5 size-3.5 shrink-0 text-primary" aria-hidden="true" />
        <span className="min-w-0">
          <span className="sr-only">{PEE_ARIA} Insight: </span>
          {insight.headline}
        </span>
      </p>
      <p className="mt-1 pl-[22px] text-sm leading-relaxed text-muted-foreground">
        {insight.detail}
      </p>
      {action ? (
        <div className="mt-2 pl-[18px]">
          <Button
            variant="ghost"
            size="sm"
            className="h-7 px-2 text-primary"
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        </div>
      ) : null}
    </aside>
  );
}
